const partnerCategories = [
  { name: '漫画平台', count: '12家' },
  { name: '动漫资讯', count: '8家' },
  { name: '二次元社区', count: '15家' },
  { name: '周边电商', count: '6家' },
  { name: '声优工作室', count: '4家' },
  { name: '同人创作', count: '10家' },
];

export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-background-100 border-t border-background-200/60">
      {/* Partners */}
      <div className="w-full px-4 md:px-6 py-10 border-b border-background-200/60">
        <div className="text-center mb-6">
          <h4 className="font-heading text-lg text-foreground-950 mb-1">合作伙伴</h4>
          <p className="text-xs text-foreground-400">以下领域合作伙伴排名不分先后</p>
        </div>
        <div className="max-w-4xl mx-auto grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-3">
          {partnerCategories.map((p) => (
            <div
              key={p.name}
              className="flex flex-col items-center gap-1 p-4 rounded-xl border border-background-200/70 bg-background-50"
            >
              <span className="text-sm font-medium text-foreground-700">{p.name}</span>
              <span className="text-xs text-foreground-400">{p.count}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Main Footer */}
      <div className="w-full px-4 md:px-6 py-10">
        <div className="flex flex-col lg:flex-row items-start gap-8 lg:gap-16">
          {/* Brand */}
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-book-open-line text-base text-white"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-950">古古漫画网</span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed max-w-md mb-4">
              古古漫画网免费提供海量全集漫画，下拉式阅读极致体验，日漫韩漫国漫大全免费看，最新连载实时更新，高清无广告。好看的漫画在线看全集，尽在古古漫画网。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-500 hover:text-primary-500 hover:bg-primary-100 transition-colors cursor-pointer no-underline">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-500 hover:text-primary-500 hover:bg-primary-100 transition-colors cursor-pointer no-underline">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-500 hover:text-primary-500 hover:bg-primary-100 transition-colors cursor-pointer no-underline">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <h4 className="text-sm font-medium text-foreground-950 mb-3">快速导航</h4>
              <div className="flex flex-col gap-2">
                <a href="#cards" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer no-underline">热门推荐</a>
                <a href="#ranking" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer no-underline">人气榜单</a>
                <a href="#carousel" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer no-underline">专题精选</a>
                <a href="#features" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer no-underline">平台特色</a>
              </div>
            </div>
            <div>
              <h4 className="text-sm font-medium text-foreground-950 mb-3">漫画分类</h4>
              <div className="flex flex-col gap-2">
                <a href="#index" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer no-underline">日漫免费</a>
                <a href="#index" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer no-underline">韩漫免费</a>
                <a href="#index" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer no-underline">国漫免费</a>
                <a href="#index" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer no-underline">漫画大全</a>
              </div>
            </div>
            <div>
              <h4 className="text-sm font-medium text-foreground-950 mb-3">关于我们</h4>
              <div className="flex flex-col gap-2">
                <a href="#about" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer no-underline">平台介绍</a>
                <a href="#contact" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer no-underline">联系我们</a>
                <a href="#faq" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer no-underline">常见问题</a>
                <a href="#app" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer no-underline">移动端</a>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2020 - 2026 古古漫画网 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer no-underline">用户协议</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer no-underline">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer no-underline">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}